export const percentageToFraction = (percentage: number) => percentage / 100
